import {
  AnalyzeCurrentPagePlan,
  createDecodeTraceCallPlan,
  createFullContractAnalysisPlan,
  createFullDecoderPlan,
  createFullWalletProfilePlan,
  createKYCInvestigationPlan,
  createNextTracerNodePlan,
} from './workflowFunctions';
import { workflowTypes } from './workflowTypes';

import { useTracerStore } from 'blockscope/components/tracer/utils/tracerStore';

// This function handles building the action plan when a workflow is triggered
export const handleWorkflowTrigger = (
  workflowType,
  location,
  state,
  chatSessionId,
  locationSearchParams
) => {
  const getWalletDetailsFromUrl = (location) => {
    const pathParts = location.split('/');
    if (pathParts.length >= 4) {
      return {
        chain: pathParts[2],
        address: pathParts[3].split('?')[0],
      };
    }
    return null;
  };

  const getContractAnalysisFromUrl = (location) => {
    const pathParts = location.split('/');
    if (pathParts.length >= 4) {
      return {
        chain: pathParts[2],
        address: pathParts[3].split('?')[0],
      };
    }
    return null;
  };

  const getTxnDetailsFromUrl = (location) => {
    const pathParts = location.split('/');
    if (pathParts.length >= 4) {
      return {
        chain: pathParts[2],
        txnHash: pathParts[3].split('?')[0],
      };
    }
    return null;
  };

  const getTracerIdFromUrl = () => {
    const searchParams = new URLSearchParams(locationSearchParams);
    const tracerId = searchParams.get('tracerId');
    return tracerId || null;
  };

  let plan;

  switch (workflowType) {
    case workflowTypes.INVESTIGATE_FULL_WALLET_PROFILE:
    case workflowTypes.INVESTIGATE_WALLET_FOR_KYC_DATA:
    case workflowTypes.INVESTIGATE_WALLET_FOR_ILLICIT_ACTIVITY: {
      const walletDetails = getWalletDetailsFromUrl(location);
      if (walletDetails) {
        if (workflowType === workflowTypes.INVESTIGATE_FULL_WALLET_PROFILE) {
          plan = createFullWalletProfilePlan(
            walletDetails.chain,
            walletDetails.address,
            state
          );
        } else if (
          workflowType === workflowTypes.INVESTIGATE_WALLET_FOR_KYC_DATA
        ) {
          plan = createKYCInvestigationPlan(
            walletDetails.chain,
            walletDetails.address,
            state
          );
        }
      }
      break;
    }

    case workflowTypes.INVESTIGATE_FULL_DECODER:
    case workflowTypes.ANALYZE_DECODER_TRACE_CALL: {
      const txnDetails = getTxnDetailsFromUrl(location);
      if (txnDetails) {
        if (workflowType === workflowTypes.INVESTIGATE_FULL_DECODER) {
          plan = createFullDecoderPlan(
            txnDetails.chain,
            txnDetails.txnHash,
            state
          );
        } else if (workflowType === workflowTypes.ANALYZE_DECODER_TRACE_CALL) {
          plan = createDecodeTraceCallPlan(
            txnDetails.chain,
            txnDetails.txnHash,
            state
          );
        }
      }
      break;
    }
    case workflowTypes.INVESTIGATE_FULL_CONTRACT_ANALYSIS: {
      const contractDetails = getContractAnalysisFromUrl(location);
      if (contractDetails) {
        plan = createFullContractAnalysisPlan(
          contractDetails.chain,
          contractDetails.address,
          state
        );
      }
      break;
    }

    case workflowTypes.ANALYZE_CURRENT_PAGE: {
      plan = AnalyzeCurrentPagePlan();
      break;
    }
    case workflowTypes.FIND_NEXT_TRACER_NODE: {
      const tracerId = getTracerIdFromUrl();
      const nodes = useTracerStore.getState().nodes;
      plan = createNextTracerNodePlan(nodes, tracerId);
      break;
    }
    default:
      console.warn('Unknown workflow type:', workflowType);
      return null;
  }

  if (plan) {
    plan.chatSessionId = chatSessionId;
    return plan;
  } else {
    console.warn('Could not extract required details from URL');
    return null;
  }
};

